/*eslint-disable*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import CustomHeader from "components/Header/CustomHeader.js";
import Parallax from "components/Parallax/Parallax.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomFooter from "components/Footer/CustomFooter";
// sections for this page
import SectionPatientInfoPills from "./Sections/SectionPatientInfoPills";
import pricingStyle from "assets/jss/material-kit-pro-react/views/pricingStyle.js";

const useStyles = makeStyles(pricingStyle);

export default function PatientInfoPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();
  return (
    <div>
      <CustomHeader />
      <Parallax
        image={require("assets/img/patientinfo.jpg").default}
        filter="dark"
        small
      >
        <div className={classes.container}>
          <GridContainer>
            <GridItem
              md={8}
              sm={8}
              className={classNames(
                classes.mlAuto,
                classes.mrAuto,
                classes.textCenter
              )}
            >
              <h1 className={classes.title}>Patient Information</h1>
              <h4>
                Here you can find information such as patient forms, insurance plans, policies, pre-testing preparation, and hospital affiliations to keep you 
                well informed with how we operate with transparency so you can feel comfortable and confident with putting your health in our hands.
              </h4>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <SectionPatientInfoPills />
          <hr />
          {/* <SectionBlogs /> */}
        </div>
      </div>
      <CustomFooter />
    </div>
  );
}
